import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getDocumentPlaceholders() {
    try {
        const response = await apiGet('core','document-placeholders');
        return response;
    } catch (e) { }
}

